import React from 'react';
import styled from 'styled-components';

const Section = styled.section` padding: 5rem 1rem; background: var(--background-light); `;
const Inner = styled.div` max-width: 1200px; margin: 0 auto; `;

const Head = styled.div`
  text-align: center; max-width: 720px; margin: 0 auto 3rem;
  .tag {
    display: inline-block;
    padding: 0.35rem 0.9rem; border-radius: 999px;
    border: 1px solid rgba(255,255,255,0.15);
    background: rgba(0,153,0,0.08); color: var(--primary-color);
    font-size: 0.75rem; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
    margin-bottom: 1rem;
  }
  h2 { font-size: clamp(1.75rem, 3.2vw, 2.5rem); margin: 0 0 0.75rem; color: var(--text-color); span { color: var(--primary-color); } }
  p { color: var(--text-secondary); line-height: 1.7; margin: 0; }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
  @media (max-width: 700px) { grid-template-columns: 1fr; }
`;

const Card = styled.article`
  background: rgba(255,255,255,0.03);
  border: 1px solid rgba(0, 153, 0, 0.15);
  border-radius: var(--border-radius);
  padding: 1.75rem;
  transition: transform 0.25s ease, border-color 0.25s ease;
  &:hover { transform: translateY(-4px); border-color: var(--primary-color); }

  .num {
    display: inline-block;
    color: var(--primary-color);
    font-weight: 800; font-size: 0.85rem;
    letter-spacing: 0.1em;
    margin-bottom: 0.6rem;
  }
  h3 { font-size: 1.15rem; margin: 0 0 0.5rem; color: var(--text-color); }
  p { color: var(--text-secondary); margin: 0; line-height: 1.65; }
`;

const CASES = [
  { num: 'Use case 01', title: 'Rehearsing large USDT trades before going live',
    desc: 'Preview how a $500K or $5M USDT balance renders on a counterparty wallet before you ever commit real Tether. Great for high-value P2P and OTC trades.' },
  { num: 'Use case 02', title: 'Product demos for USDT payment startups',
    desc: 'Show working USDT deposit flows to investors, partners, or beta users without wiring up real Tether custody. Present the exact wallet screens buyers will see.' },
  { num: 'Use case 03', title: 'QA testing for wallets and dApps',
    desc: 'Test how your UI renders USDT balances across TRC-20, ERC-20 and BEP-20 without spending mainnet gas or waiting for expensive testnet USDT.' },
  { num: 'Use case 04', title: 'Training crypto support and compliance staff',
    desc: 'Walk teams through what a USDT transaction looks like inside real wallets and explorers — with realistic balances they can practice against.' },
  { num: 'Use case 05', title: 'Content creators & educators',
    desc: 'Produce YouTube tutorials, articles, or documentation showing USDT balances and transfers without exposing real funds on-camera.' },
  { num: 'Use case 06', title: 'Betting & gaming platform stress-testing',
    desc: 'Validate deposit and confirmation flows against realistic USDT amounts before opening to real users. Catch UX and edge-case bugs early.' },
];

const UseCases: React.FC = () => (
  <Section id="use-cases">
    <Inner>
      <Head>
        <div className="tag">Use cases</div>
        <h2>Real ways teams use <span>flash USDT software</span></h2>
        <p>Six of the most common reasons customers buy from us — pick whichever describes your workflow.</p>
      </Head>
      <Grid>
        {CASES.map((c) => (
          <Card key={c.title}>
            <span className="num">{c.num}</span>
            <h3>{c.title}</h3>
            <p>{c.desc}</p>
          </Card>
        ))}
      </Grid>
    </Inner>
  </Section>
);

export default UseCases;
